export default "__VITE_ASSET__vkm$UwXi__"